class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.isHovering = false;
    this.closeTimeout = null;
    this.setupHoverBehavior();
  }

  setupHoverBehavior() {
    // Only apply hover behavior on desktop (screen width > 990px)
    if (window.matchMedia('(min-width: 990px)').matches) {
      const summary = this.querySelector('summary');
      const content = this.querySelector('.mega-menu__content');
      
      // Add hover listeners to the trigger
      if (summary) {
        summary.addEventListener('mouseenter', this.onMouseEnter.bind(this));
        summary.addEventListener('mouseleave', this.onMouseLeave.bind(this));
        
        // Prevent click from toggling on desktop
        summary.addEventListener('click', (e) => {
          if (window.matchMedia('(min-width: 990px)').matches) {
            e.preventDefault();
          }
        });
      }
      
      // Add hover listeners to the content dropdown
      if (content) {
        content.addEventListener('mouseenter', this.onMouseEnter.bind(this));
        content.addEventListener('mouseleave', this.onMouseLeave.bind(this));
      }
    }
    
    // Re-check on window resize
    window.addEventListener('resize', () => {
      this.updateHoverBehavior();
    });
  }

  updateHoverBehavior() {
    // This ensures behavior stays correct after resize
    if (!window.matchMedia('(min-width: 990px)').matches) {
      this.close();
    }
  }

  onMouseEnter() {
    if (window.matchMedia('(min-width: 990px)').matches) {
      this.isHovering = true;
      // Clear any pending close timeout
      if (this.closeTimeout) {
        clearTimeout(this.closeTimeout);
        this.closeTimeout = null;
      }
      this.open();
    }
  }

  onMouseLeave() {
    if (window.matchMedia('(min-width: 990px)').matches) {
      this.isHovering = false;
      // Add a small delay before closing to allow smooth transition between elements
      this.closeTimeout = setTimeout(() => {
        if (!this.isHovering) {
          this.close();
        }
      }, 150);
    }
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    this.onToggle();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
